export default __webpack_public_path__ + "static/media/hvar1.3785b0ef.jpg";